import React, { Component } from 'react'

import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,  MDBBreadcrumb, MDBBreadcrumbItem } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBJumbotron, MDBBox } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
//import Login from './Login';
import Axios from 'axios'
import { URL } from '../../api';
import logo from '../img/logokpru.png'
import FadeIn from 'react-fade-in';
import p1 from '../img/1656587759_2-illustration_png.png'
import p2 from '../img/1656587759_4-illustration_png.png'
import p3 from '../img/1656587761_12-illustration_png.png'
import Iframe from 'react-iframe'
import IframeResizer from 'iframe-resizer-react'

import { HorizontalBar } from 'react-chartjs-2';


import Swal from 'sweetalert2'
import {
  MDBTypography,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from 'mdbreact';


export default class Studentmov extends Component {


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClick = this.onClick.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
  }

  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  refreshPage() {
    window.location.reload(false);
  }

  handleChange(event) { this.setState({ value: event.target.value }); }
  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }

  handleSubmit(event) {
    // alert('A name was submitted: ' + this.state.value);
    event.preventDefault();

    const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
    datafrm.append("txtemail", this.state.value);
    datafrm.append("txtpass", this.state.Psaaword);


    const user = {
      "txtemail": this.state.value,
      "txtpass": this.state.Psaaword
    };

    fetch('https://mua.kpru.ac.th/FrontEnd_Mis/login/login/', {
      method: 'POST',
      body: JSON.stringify(user),
      headers: {

      }
    })
      .then(res => res.json())
      .then((res) => {
        console.log(res);
        if (res[0].loginstatus === "1") {


          //  alert("เข้าสู่ระบบสำเร็จ")

          localStorage.setItem('name', res[0].frist_name + "  " + res[0].last_name);

          message.success("เข้าสู่ระบบสำเร็จ")
          localStorage.setItem('loginstatus', res[0].loginstatus);
          localStorage.setItem('type2', res[0].employee_id);
          localStorage.setItem('admin_type', 2);

          window.location.href = '/vaccinekpru/Stuall'
        } else {


          Swal.fire(
            'ไม่สามารถเข้าถึงระบบได้',
            'กรุณาลองอีกครั้ง',
            'question'
          )

        }

      })
      .catch(err => {
        console.log('request failed', err);
      })
  }


  update = () => {
    this.setState({
      name: "",
      lname: ""
    })
  }

  componentDidMount() {
    console.log('dddd')
  }


  render() {

    const dataHorizontal = {
      labels: ['Red', 'Orange', 'Yellow', 'Green', 'Blue', 'Purple', 'Grey'],
      datasets: [
        {
          label: 'My First Dataset',
          data: [22, 33, 55, 12, 86, 23, 14],
          fill: false,
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(201, 203, 207, 0.2)'
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
          ],
          borderWidth: 1
        }
      ]
    }



    return (

      <MDBContainer fluid>
       
        <MDBRow >
          <MDBCol md="12">
            <div>
              {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
              {/* <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/> */}
              <FadeIn>
              <MDBJumbotron className="p-4" fluid >
                 
                <MDBTypography blockquote bqColor='primary' className='h-0'>
                  <MDBIcon icon="user-injured" />   จำนวนนักศึกษาต่างชาติ
                </MDBTypography>
                {/* <MDBTypography note noteColor='primary' noteTitle='ด้านนักศึกษา '> </MDBTypography> */}
                   <MDBBreadcrumb>
                        <MDBBreadcrumbItem>Home</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>จำนวนนักศึกษาต่างชาติ</MDBBreadcrumbItem>
                    </MDBBreadcrumb>
                    <div className='text-right'> <a href='/welcome'><MDBBtn  color="blue-grey" size='sm'><MDBIcon icon="caret-left" /> กลับหน้าหลัก</MDBBtn></a><MDBBtn  color="mdb-color" size='sm' onClick={this.refreshPage}><MDBIcon icon="redo" /> refresh</MDBBtn></div>
                {/* <div >
                  <MDBRow >
                    <MDBCol sm="6" >
                    <div className="mb-2">
                    <label>ภาคการเรียน</label>
                        <select className="browser-default custom-select">
                        <option>เลือกภาคการเรียน</option>
                        <option value="1">Option 1</option>
                        <option value="2">Option 2</option>
                        <option value="3">Option 3</option>
                        </select>
                    </div>
                    </MDBCol>

                    <MDBCol sm="4" className='d-flex justify-content-center'>
                    </MDBCol>
                  </MDBRow>
                </div> */}
                            {/* <br/> */}

                            <p>ระบบโหลดข้อมูลจำนวนมาก กรุณารอสักครู่</p>
                            {/* <iframe src="https://datastudio.google.com/embed/reporting/c100fb1c-4c88-41ea-b941-b9c2e83a3935/page/Cds4C" frameborder="0" style="overflow:hidden;height:100%;width:100%" height="100%" width="100%"></iframe> */}
                            {/* <Iframe url="https://datastudio.google.com/embed/reporting/9104237d-2eb8-4abd-8b1e-90f17e837fae/page/0lA9C"
                                width="100%" height="600px"
                                 id=""
                                 className=""
                                 display="block"
                                 position="relative"/> */}

                                   <Iframe url="https://lookerstudio.google.com/embed/reporting/e557b2b9-e1d2-4b14-b49d-53226e9eb78b/page/Q1zmD"
                                width="100%" height="800px"
                                 id=""
                                 className=""
                                 display="block"
                                 position="relative"/>
                                 

{/* <IframeResizer
  log
  src="https://datastudio.google.com/embed/reporting/c100fb1c-4c88-41ea-b941-b9c2e83a3935/page/Cds4C"
  style={{ width: '1px', minWidth: '100%'}}
/> */}
{/* <IframeResizer
        forwardRef={iframeRef}
        heightCalculationMethod="lowestElement"
        inPageLinks
        log
        onMessage={onMessage}
        onResized={onResized}
        src="https://datastudio.google.com/embed/reporting/c100fb1c-4c88-41ea-b941-b9c2e83a3935/page/Cds4C"
        style={{ width: '1px', minWidth: '100%'}}
      /> */}

{/* <iframe width="600" height="450" src="https://datastudio.google.com/embed/reporting/c100fb1c-4c88-41ea-b941-b9c2e83a3935/page/Cds4C" frameborder="0" style="border:0" allowfullscreen></iframe> */}


                             {/* <HorizontalBar
                              data={dataHorizontal}
                              options={{ responsive: true }}
                            /> */}
                            <br/>
                {/* <MDBTypography blockquote bqColor='primary' className='h-0'>
                  <MDBIcon icon="user-injured" />   จำนวนผู้สมัครแต่ละคณะ
                </MDBTypography> */}

              

{/*            
<div className='text-center'> <a href='/'><MDBBtn  color="blue-grey" size='sm'><MDBIcon icon="caret-left" /> กลับหน้าหลัก</MDBBtn></a></div>

               
                <div >  <MDBIcon icon="caret-left" /><a href='/Studentschoolreport'> จำนวนนักเรียนมัธยมแต่ละโรงเรียน</a></div>
               <div > <MDBIcon icon="caret-left"  /> จำนวนผู้เข้าชม</div> */}
              </MDBJumbotron>
              </FadeIn>
            </div>
          </MDBCol>
        </MDBRow>

      </MDBContainer>


    )
  }
}
